module.exports = (__parcel__import__("MUAox")).then(() => parcelRequire('fyWP3'));